import styled from "styled-components";
import { HealthAddressFormContainer } from "../../../health/forms/address-item/address-form-item-style";

export const ForeignersHealthAddressContainer = styled(HealthAddressFormContainer)``;
